import { useTranslation } from 'react-i18next';
import PageHeader from './PageHeader';

/**
 * Shared "you have no layout access on this band" panel.
 *
 * Shown by <RequireLayoutAccess> on the 3 PDF layout routes (rider / daysheet /
 * tourbook) and by the editors themselves when the working user is not allowed
 * to edit layouts (see src/lib/layoutAccess.ts). The API answers 403 on a write
 * too, but the guard must never let a user reach an editor they cannot save:
 * the panel is the real page-level gate, not a fallback for a failed request.
 * (2026-09-24)
 */
export default function LayoutAccessDenied({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  return (
    <div className="page">
      <PageHeader title={t(titleKey)} />
      <p className="empty-hint">{t('layoutEditor.noAccess')}</p>
    </div>
  );
}